var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.searchApi.loading)?_vm._t("loading",[_vm._v("\n    Loading...\n  ")],{"loading":_vm.searchApi.loading}):_vm._t("default",null,{"listings":_vm.compResults})],2)}
var staticRenderFns = []

export { render, staticRenderFns }